import { Union, Record } from "./.fable/fable-library.3.1.16/Types.js";
import { lambda_type, unit_type, uint8_type, union_type, array_type, float32_type, option_type, float64_type, class_type, tuple_type, int32_type, record_type, string_type, bool_type } from "./.fable/fable-library.3.1.16/Reflection.js";
import { toSeq, ofSeq, difference, empty, add, minElement } from "./.fable/fable-library.3.1.16/Set.js";
import { containsKey, tryFind, count, toList } from "./.fable/fable-library.3.1.16/Map.js";
import { fold } from "./.fable/fable-library.3.1.16/List.js";
import { equalArrays, compare, comparePrimitives } from "./.fable/fable-library.3.1.16/Util.js";
import { rangeDouble } from "./.fable/fable-library.3.1.16/Range.js";
import { sort, tryItem } from "./.fable/fable-library.3.1.16/Seq.js";
import { bind } from "./.fable/fable-library.3.1.16/Option.js";

export class Jack extends Record {
    constructor(out, label) {
        super();
        this.out = out;
        this.label = label;
    }
}

export function Jack$reflection() {
    return record_type("Patchy.Client.Model.Jack", [], Jack, () => [["out", bool_type], ["label", string_type]]);
}

export class Cable extends Record {
    constructor(src, dest, id) {
        super();
        this.src = src;
        this.dest = dest;
        this.id = (id | 0);
    }
}

export function Cable$reflection() {
    return record_type("Patchy.Client.Model.Cable", [], Cable, () => [["src", tuple_type(tuple_type(int32_type, int32_type), int32_type)], ["dest", tuple_type(tuple_type(int32_type, int32_type), int32_type)], ["id", int32_type]]);
}

export class NewCable extends Record {
    constructor(start, cursor) {
        super();
        this.start = start;
        this.cursor = cursor;
    }
}

export function NewCable$reflection() {
    return record_type("Patchy.Client.Model.NewCable", [], NewCable, () => [["start", tuple_type(tuple_type(tuple_type(int32_type, int32_type), int32_type), class_type("Browser.Types.ClientRect"))], ["cursor", tuple_type(float64_type, float64_type)]]);
}

export class OscState extends Record {
    constructor(nodes, detune, freq) {
        super();
        this.nodes = nodes;
        this.detune = detune;
        this.freq = freq;
    }
}

export function OscState$reflection() {
    return record_type("Patchy.Client.Model.OscState", [], OscState, () => [["nodes", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, class_type("Fable.WebAudio.OscillatorNode")])], ["detune", class_type("Fable.WebAudio.AudioParam")], ["freq", class_type("Fable.WebAudio.AudioParam")]]);
}

export class LfoState extends Record {
    constructor(nodes, dcOffset, rate) {
        super();
        this.nodes = nodes;
        this.dcOffset = dcOffset;
        this.rate = rate;
    }
}

export function LfoState$reflection() {
    return record_type("Patchy.Client.Model.LfoState", [], LfoState, () => [["nodes", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, class_type("Fable.WebAudio.AudioWorkletNode")])], ["dcOffset", class_type("Fable.WebAudio.AudioParam")], ["rate", class_type("Fable.WebAudio.AudioParam")]]);
}

export class IOState extends Record {
    constructor(merger, midiPitch) {
        super();
        this.merger = merger;
        this.midiPitch = midiPitch;
    }
}

export function IOState$reflection() {
    return record_type("Patchy.Client.Model.IOState", [], IOState, () => [["merger", class_type("Fable.WebAudio.ChannelMergerNode")], ["midiPitch", class_type("Fable.WebAudio.AudioNode")]]);
}

export class ScopeState extends Record {
    constructor(analyser, frameDuration, offset, range, canvas, timeDomainData) {
        super();
        this.analyser = analyser;
        this.frameDuration = frameDuration;
        this.offset = (offset | 0);
        this.range = range;
        this.canvas = canvas;
        this.timeDomainData = timeDomainData;
    }
}

export function ScopeState$reflection() {
    return record_type("Patchy.Client.Model.ScopeState", [], ScopeState, () => [["analyser", class_type("Fable.WebAudio.AudioWorkletNode")], ["frameDuration", float64_type], ["offset", int32_type], ["range", float64_type], ["canvas", option_type(class_type("Browser.Types.HTMLCanvasElement"))], ["timeDomainData", array_type(float32_type)]]);
}

export class GainState extends Record {
    constructor(i, o, value) {
        super();
        this.i = i;
        this.o = o;
        this.value = value;
    }
}

export function GainState$reflection() {
    return record_type("Patchy.Client.Model.GainState", [], GainState, () => [["i", class_type("Fable.WebAudio.GainNode")], ["o", class_type("Fable.WebAudio.GainNode")], ["value", class_type("Fable.WebAudio.AudioParam")]]);
}

export class VcfState extends Record {
    constructor(i, freq, o) {
        super();
        this.i = i;
        this.freq = freq;
        this.o = o;
    }
}

export function VcfState$reflection() {
    return record_type("Patchy.Client.Model.VcfState", [], VcfState, () => [["i", class_type("Fable.WebAudio.BiquadFilterNode")], ["freq", class_type("Fable.WebAudio.GainNode")], ["o", class_type("Fable.WebAudio.BiquadFilterNode")]]);
}

export class ModState extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Osc", "Lfo", "Scope", "Out", "Gain", "Vcf"];
    }
}

export function ModState$reflection() {
    return union_type("Patchy.Client.Model.ModState", [], ModState, () => [[["Item", OscState$reflection()]], [["Item", LfoState$reflection()]], [["Item", ScopeState$reflection()]], [["Item", IOState$reflection()]], [["Item", GainState$reflection()]], [["Item", VcfState$reflection()]]]);
}

export class KnobConfig extends Record {
    constructor(min, max, steps) {
        super();
        this.min = min;
        this.max = max;
        this.steps = (steps | 0);
    }
}

export function KnobConfig$reflection() {
    return record_type("Patchy.Client.Model.KnobConfig", [], KnobConfig, () => [["min", float64_type], ["max", float64_type], ["steps", int32_type]]);
}

export class ControlConfig extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["KnobConfig"];
    }
}

export function ControlConfig$reflection() {
    return union_type("Patchy.Client.Model.ControlConfig", [], ControlConfig, () => [[["Item", KnobConfig$reflection()]]]);
}

export class Control extends Record {
    constructor(label, config) {
        super();
        this.label = label;
        this.config = config;
    }
}

export function Control$reflection() {
    return record_type("Patchy.Client.Model.Control", [], Control, () => [["label", string_type], ["config", ControlConfig$reflection()]]);
}

export class ModDef extends Record {
    constructor(name, dimensions, controls, jacks) {
        super();
        this.name = name;
        this.dimensions = dimensions;
        this.controls = controls;
        this.jacks = jacks;
    }
}

export function ModDef$reflection() {
    return record_type("Patchy.Client.Model.ModDef", [], ModDef, () => [["name", string_type], ["dimensions", tuple_type(int32_type, int32_type)], ["controls", class_type("Microsoft.FSharp.Collections.FSharpSet`1", [Control$reflection()])], ["jacks", class_type("Microsoft.FSharp.Collections.FSharpSet`1", [Jack$reflection()])]]);
}

export class Mod extends Record {
    constructor(def, state) {
        super();
        this.def = def;
        this.state = state;
    }
}

export function Mod$reflection() {
    return record_type("Patchy.Client.Model.Mod", [], Mod, () => [["def", ModDef$reflection()], ["state", ModState$reflection()]]);
}

export function middle(clientRect) {
    return [clientRect.left + (clientRect.width / 2), clientRect.top + (clientRect.height / 2)];
}

export function nextId(cables) {
    let set2, list;
    return minElement((set2 = (list = toList(cables), fold((acc, tupledArg) => add(tupledArg[1].id, acc), empty({
        Compare: (x, y) => comparePrimitives(x, y),
    }), list)), difference(ofSeq(rangeDouble(0, 1, 1 + count(cables)), {
        Compare: (x_2, y_2) => comparePrimitives(x_2, y_2),
    }), set2)));
}

export class ControlChangeEvent extends Record {
    constructor(position, name, value) {
        super();
        this.position = position;
        this.name = name;
        this.value = value;
    }
}

export function ControlChangeEvent$reflection() {
    return record_type("Patchy.Client.Model.ControlChangeEvent", [], ControlChangeEvent, () => [["position", tuple_type(int32_type, int32_type)], ["name", string_type], ["value", float64_type]]);
}

export class LoadingState extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Cables", "Modules", "Loaded"];
    }
}

export function LoadingState$reflection() {
    return union_type("Patchy.Client.Model.LoadingState", [], LoadingState, () => [[], [], []]);
}

export class Model extends Record {
    constructor(mods, jackRefs, cables, newCable, loading, audioContext, addMenuPosition) {
        super();
        this.mods = mods;
        this.jackRefs = jackRefs;
        this.cables = cables;
        this.newCable = newCable;
        this.loading = loading;
        this.audioContext = audioContext;
        this.addMenuPosition = addMenuPosition;
    }
}

export function Model$reflection() {
    return record_type("Patchy.Client.Model.Model", [], Model, () => [["mods", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [tuple_type(int32_type, int32_type), Mod$reflection()])], ["jackRefs", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [tuple_type(tuple_type(int32_type, int32_type), int32_type), class_type("Browser.Types.HTMLElement")])], ["cables", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [tuple_type(tuple_type(int32_type, int32_type), int32_type), Cable$reflection()])], ["newCable", option_type(NewCable$reflection())], ["loading", LoadingState$reflection()], ["audioContext", class_type("Fable.WebAudio.AudioContext")], ["addMenuPosition", option_type(tuple_type(int32_type, int32_type))]]);
}

export class Message extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["ClickBlank", "RemoveModule", "AddMod", "JackMouseDown", "JackMouseUp", "CloseAddMenu", "CableClick", "MouseMove", "CancelChord", "WindowResize", "ModConnect", "Animate", "MIDIData", "Error", "ControlChange", "AddScope", "ScopeData", "ScopeRender", "JackRender", "Saved", "Loading"];
    }
}

export function Message$reflection() {
    return union_type("Patchy.Client.Model.Message", [], Message, () => [[["Item", tuple_type(int32_type, int32_type)]], [["Item", tuple_type(int32_type, int32_type)]], [["Item1", tuple_type(int32_type, int32_type)], ["Item2", string_type]], [["Item", tuple_type(tuple_type(int32_type, int32_type), int32_type)]], [["Item", tuple_type(tuple_type(int32_type, int32_type), int32_type)]], [], [["Item", Cable$reflection()]], [["Item", tuple_type(float64_type, float64_type)]], [], [], [["Item", tuple_type(bool_type, Cable$reflection())]], [["Item", float64_type]], [["Item", array_type(uint8_type)]], [], [["Item", ControlChangeEvent$reflection()]], [["Item1", tuple_type(int32_type, int32_type)], ["Item2", lambda_type(Message$reflection(), unit_type)]], [["Item1", tuple_type(int32_type, int32_type)], ["Item2", array_type(float32_type)]], [["Item1", tuple_type(int32_type, int32_type)], ["Item2", class_type("Browser.Types.HTMLCanvasElement")]], [["Item1", tuple_type(tuple_type(int32_type, int32_type), int32_type)], ["Item2", class_type("Browser.Types.HTMLElement")]], [], [["Item", LoadingState$reflection()]]]);
}

export function getModJack(jackNumber, _arg1) {
    return tryItem(jackNumber, sort(toSeq(_arg1.def.jacks), {
        Compare: (x, y) => compare(x, y),
    }));
}

export function getJack(_arg2_0, _arg2_1, _arg1) {
    const _arg2 = [_arg2_0, _arg2_1];
    return bind((arg10$0040) => getModJack(_arg2[1], arg10$0040), tryFind(_arg2[0], _arg1.mods));
}

export function validateJackPair(idA, _arg3, idB, _arg2, _arg1) {
    let matchValue;
    const outA = _arg3.out;
    return bind((pair) => {
        const pair_1 = pair;
        if (!containsKey(pair_1[1], _arg1.cables)) {
            return pair_1;
        }
        else {
            return void 0;
        }
    }, (matchValue = ((!equalArrays(idA, idB)) ? (outA !== _arg2.out) : false), matchValue ? (outA ? [idA, idB] : (matchValue ? [idB, idA] : (void 0))) : (matchValue ? [idB, idA] : (void 0))));
}

